import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import Tenant from '@/pages/Workspace/Tenant';
import ErrorPage from '@/pages/Workspace/ErrorPage';
import i18n, { setBackendLanguage } from '@/i18n/i18n';
import '@static/css/index.css';
import './index.less';

setBackendLanguage(i18n.language || 'en')

export enum Themes {
  Dark = 'dark',
  Light = 'light',
  White = 'white',
}

const WorkspaceRouter = () => {
  const url = new URL(window.location.href);
  const URLtheme = url.searchParams.get('theme') as Themes | null;
  const [styleHheme] = React.useState<Themes>(URLtheme || Themes.Light);
  const isDark = styleHheme === Themes.Dark;

  React.useEffect(() => {
    // if (URLtheme) {
    //   localStorage.theme = URLtheme;
    // }

    // 给body添加主题
    if (isDark) {
      document.body.classList.add(Themes.Dark);
    } else {
      document.body.classList.remove(Themes.Dark);
    }
  }, [isDark]);

  const token: any = {
    colorPrimary: '#1890ff',
    borderRadius: 2,
  }

  if (isDark) {
    token.colorBgContainer = 'transparent';
    token.colorBorder = '#434343';
    token.colorText = 'hsla(0, 0%, 100%, 0.85)'
  }

  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token,
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route
              path="/"
              element={
                <Tenant />
              }
            />
            <Route
              path="/error"
              element={
                <ErrorPage />
              }
            />
            <Route
              path="workspace"
              element={
                <Tenant />
              }
            />
            <Route
              path="teamsapp"
              element={
                <Tenant />
              }
            />
            <Route
              path="slackapp"
              element={
                <Tenant />
              }
            />
          <Route path="*" element={<div>Not found</div>} />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default WorkspaceRouter;